import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, ConfirmationComponent, Pager, Product, ProductService } from 'lib-trend-core';
import { debounceTime, distinctUntilChanged, finalize, Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { ProductFormModalComponent } from './product-form-modal/product-form-modal.component';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrl: './product.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductComponent extends AbstractComponent {
  public pager: Pager<Product> = new Pager<Product>({ perPage: 10 });
  listObservable: Observable<Pager<Product>>;
  private searchTerm: Subject<string> = new Subject<string>();

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private productService: ProductService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getList();
  }


  setupObservableSearch() {
    this.listObservable = this.searchTerm
      .pipe(takeUntil(this.destroy$))
      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .pipe(switchMap(term => {
        return this.productService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams);
      }));
    this.listObservable.subscribe((pager: Pager<Product>) => {
      this.pager = pager;
    });
  }

  getList() {
    this.loadingContent = true;

    this.searchParams = {
      company: this.getIDCurrentCompany(),
    };

    this.productService.getAll(this.pager.page, this.pager.perPage, this.searchString, this.searchParams)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loadingContent = false)
      )
      .subscribe({
        next: (pager: Pager<Product>) => {
          this.pager = pager;
          this.setupObservableSearch();
        },
      });
  }

  search(termo: string) {
    this.pager.page = 1;
    this.searchString = termo;
    this.searchTerm.next(termo);
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  add(): void {
    const dialog = this.dialog.open(ProductFormModalComponent, {
      width: '1000px',
    })

    dialog.afterClosed().pipe(takeUntil(this.destroy$))
      .subscribe((result: Product) => {
        this.getList();
      });
  }

  edit(product: Product): void {

    this.dialog.open(ProductFormModalComponent, {
      width: '1000px',
      data: product
    })
      .afterClosed().subscribe(result => {
        this.getList();
      });
  }

  delete(product: Product): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '500px',
    });

    dialogRef.afterClosed()
      .subscribe((result: boolean) => {
        if (Boolean(result) === true) {
          this.productService.delete(product._id)
            .pipe(takeUntil(this.destroy$)).subscribe({
              next: () => {
                this.alertService.success(this.t('kanban.product.deleteSuccess'));
                this.getList();
              },
              error: (error) => { this.alertService.error(error.error.message) }
            });
        }
      });
  }
}
